import { Truck, Warehouse, PackageCheck } from "lucide-react";
import PageHeader from "../components/pageHeader";
import { useTranslation } from "../../../i18n/useTranslation";

const CAPABILITIES = [
  { Icon: Truck, title: "Shipping & Transport", body: "Nationwide movement of devices between sourcing, deployment, and repair." },
  { Icon: Warehouse, title: "Warehousing", body: "Secure staging and storage for devices in transit or awaiting deployment." },
  { Icon: PackageCheck, title: "Kitting & Staging", body: "Devices pre-configured and packaged for site-ready delivery." },
];

const LogisticsPartners = () => {
  const { t } = useTranslation();
  const h = t("deviceworks.pageHeaders.logisticsPartners");
  return (
    <div>
      <PageHeader eyebrow={h.eyebrow} title={h.title} description={h.description} />
      <div className="max-w-4xl mx-auto px-5 py-16 grid grid-cols-1 md:grid-cols-3 gap-6">
        {CAPABILITIES.map(({ Icon, title, body }) => (
          <div key={title} className="dw-card text-center">
            <Icon className="mx-auto" size={28} strokeWidth={1.5} style={{ color: "var(--dw-accent)" }} />
            <h3 className="pt-3 text-base">{title}</h3>
            <p className="dw-mini pt-1 text-sm">{body}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogisticsPartners;
